export const RaListStyles = {
    styleOverrides: {
        actions: {
            marginBottom: '24px',
        },
    },
};
